// Import and register all your controllers from the importmap under controllers/*

import { application } from "./application"

import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register('nested-form', RailsNestedForm)


import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)


const componentControllers = import.meta.glob(
    '../../views/components/**/controller.js',
    { eager: false, import: 'Controller' }
)

//  Create naming map using your existing convention
const controllerNameMap = Object.keys(componentControllers).reduce((map, path) => {
    const name = path
        .match(/views\/components\/(.+)\/controller\.js$/)[1]
        .replaceAll("/", "-")
        .replaceAll("_", "-");
    map[name] = path
    return map
}, {})


const toSnakeCase = (str) => str.replace(/-/g, '_')


//  Lazy loading logic
const loadControllers = async () => {

    const controllerNames = [
        ...new Set(
            Array.from(document.querySelectorAll('[data-controller]'))
                .flatMap(el => el.dataset.controller.split(/\s+/))
        )
    ]
    await Promise.allSettled(controllerNames.map(async (name) => {

        if (application.controllers.some(c => c.identifier === name)) return

        try {
            // Try component controllers first
            if (controllerNameMap[name]) {

                const controller = await componentControllers[controllerNameMap[name]]()
                application.register(name, controller)
                return
            } 
        } catch (error) {
            console.error(`Failed to load controller: ${name}`, error)
        }
    }))
}

//  Turbo integration
document.addEventListener('turbo:load', loadControllers)
//document.addEventListener('DOMContentLoaded', loadControllers)

//  Cleanup between page transitions
document.addEventListener('turbo:before-render', () => {
    // Get all active controller identifiers
    const identifiers = [
        ...new Set(
            Array.from(document.querySelectorAll('[data-controller]'))
                .flatMap(el => el.dataset.controller.split(/\s+/))
        )
    ]
    // Unload controllers for the current page
    if (identifiers.length > 0) {
        application.unload(identifiers)
    }
})

